/* Noble & Sunday: variant-specific batch requests and paid-in-full backorders. */
(() => {
  'use strict';
  const controllers = new WeakMap();
  function init(root) {
    if (root.dataset.nsReady) return;
    const scope = root.closest('[data-section-type="product"], .shopify-section');
    const form = scope?.querySelector('form[action*="/cart/add"]');
    const primary = form?.querySelector('[data-add-to-cart], [data-add], button[name="add"]');
    if (!form || !primary) return;
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-ns-batch-variants]').textContent); } catch (_) { return; }
    root.dataset.nsReady = 'true';
    const label = primary.querySelector('[data-add-to-cart-text], [data-add-label]') || primary;
    const initialLabel = label.textContent.trim();
    const addLabel = /sold out|unavailable/i.test(initialLabel) ? 'Add to cart' : initialLabel;
    const waitlist = root.querySelector('[data-ns-batch-waitlist]');
    const preorder = root.querySelector('[data-ns-batch-preorder]');
    const details = root.querySelector('details');
    const contact = root.querySelector('form');
    const payment = form.querySelector('.payment-button-wrapper, .shopify-payment-button');
    const terms = document.createElement('label');
    terms.className = 'ns-batch-terms';
    terms.hidden = true;
    const check = document.createElement('input');
    check.type = 'checkbox'; check.disabled = true;
    const termsText = document.createElement('span');
    terms.append(check, termsText);
    primary.parentNode.insertBefore(terms, primary);
    const fields = {};
    for (const name of ['Order type', 'Estimated dispatch', 'Dispatch arrangement']) {
      const field = document.createElement('input');
      field.type = 'hidden'; field.name = `properties[${name}]`; field.disabled = true;
      form.append(field); fields[name] = field;
    }
    let current = null, lastId = null;
    function getId() { return form.querySelector('[name="id"]')?.value || root.dataset.initialVariant; }
    function update(id) {
      const v = variants.find(v => v.id === String(id));
      current = v || null;
      if (!v) {
        waitlist.hidden = preorder.hidden = terms.hidden = true;
        check.disabled = true; check.required = false;
        Object.values(fields).forEach(f => {f.disabled = true;});
        primary.disabled = true; label.textContent = 'Choose options';
        if (payment) payment.classList.add('ns-batch-payment-hidden');
        form.dataset.nsBatchState = 'unavailable';
        document.dispatchEvent(new CustomEvent('ns:batch-change'));
        return;
      }
      const isPreorder = v.state === 'preorder';
      const out = v.state === 'soldout' || isPreorder;
      form.dataset.nsBatchState = v.state;
      const consentKey = `${v.id}|${v.state}|${v.dispatch}`;
      if (lastId !== consentKey) check.checked = false;
      lastId = consentKey;
      primary.disabled = v.state === 'soldout';
      label.textContent = isPreorder ? 'Pre-order the next batch' : v.state === 'soldout' ? 'Sold out' : addLabel;
      preorder.hidden = !isPreorder;
      waitlist.hidden = !(out && v.notify);
      terms.hidden = !isPreorder; check.disabled = !isPreorder; check.required = isPreorder;
      termsText.textContent = `I understand this is a pre-order, paid in full, with estimated dispatch on ${v.dispatch}. My order will be sent together.`;
      root.querySelector('[data-ns-batch-date]').textContent = v.dispatch || '';
      fields['Order type'].value = 'Pre-order — next batch';
      fields['Estimated dispatch'].value = v.dispatch || '';
      fields['Dispatch arrangement'].value = 'Send the order together when the pre-order is ready';
      Object.values(fields).forEach(f => {f.disabled = !isPreorder;});
      if (payment) payment.classList.toggle('ns-batch-payment-hidden', out);
      scope.querySelectorAll('.ns-delivery > p').forEach(p => {p.hidden = isPreorder;});
      const stockLabel = scope.querySelector('[data-stock]');
      if (stockLabel) stockLabel.textContent = isPreorder ? 'Next batch' : out ? 'Sold out' : 'In stock';
      root.querySelector('[data-ns-batch-selection]')?.replaceChildren(document.createTextNode(`${root.dataset.productTitle} — ${v.title === 'Default Title' ? 'Standard size' : v.title}`));
      const format = root.querySelector('[data-ns-batch-format]'); if (format) format.value = v.title;
      const body = root.querySelector('[data-ns-batch-body]');
      if (body) body.value = `Please email me once when this pack size is back in stock.\n\nNS_BATCH_V1_BEGIN\nvariant=${v.id}\nhandle=${root.dataset.productHandle}\nNS_BATCH_V1_END`;
      const back = root.querySelector('[data-ns-batch-return]');
      if (back) back.value = `${location.pathname}?variant=${encodeURIComponent(v.id)}&contact_posted=true#${contact.id}`;
      document.dispatchEvent(new CustomEvent('ns:batch-change'));
    }
    const schedule = () => setTimeout(() => update(getId()), 0);
    scope.addEventListener('change', e => { if (e.target !== check && !contact.contains(e.target)) schedule(); });
    scope.addEventListener('click', e => { if (e.target.closest('[data-variant]')) schedule(); });
    // Cascade emits a jQuery event before it updates the master select.
    if (window.jQuery) window.jQuery(scope).on('variantChange.nsBatch', e => setTimeout(() => update(e.variant ? String(e.variant.id) : ''), 0));
    // Sold-out editorial sizes must remain selectable for the waitlist.
    scope.querySelectorAll('[data-variant], [name="id"] option').forEach(el => { el.disabled = false; });
    contact.addEventListener('submit', e => {
      if (!current || !current.notify || !['soldout', 'preorder'].includes(current.state)) { e.preventDefault(); return; }
      if (!contact.reportValidity()) e.preventDefault();
    });
    controllers.set(form, {get current(){return current;}, check, root, primary,
      refresh(next){variants=next;update(getId());}, bypass:false, pending:false});
    form.nsBatchOpenWaitlist = () => {
      details.open = true; root.scrollIntoView({behavior:'smooth',block:'center'});
      root.querySelector('input[type=email]')?.focus({preventScroll:true});
    };
    update(getId());
    if (root.querySelector('[data-ns-batch-success], [data-ns-batch-errors]')) { waitlist.hidden = false; details.open = true; }
  }
  function scan() { document.querySelectorAll('[data-ns-batch]').forEach(init); }
  // Window capture runs before the existing cart drawer's document listener.
  window.addEventListener('submit', async e => {
    const controller = controllers.get(e.target);
    if (!controller) return;
    if (controller.bypass) {controller.bypass=false;return;}
    const v = controller.current;
    if (!v || v.state === 'soldout' || (v.state === 'preorder' && !controller.check.checked)) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (v?.state === 'preorder') e.target.reportValidity();
      else if (v?.notify) e.target.nsBatchOpenWaitlist();
      return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    if (controller.pending) return;
    controller.pending=true;
    const form=e.target, submitter=e.submitter || controller.primary;
    const message=controller.root.querySelector('[data-ns-batch-purchase-message]');
    message.hidden=false; message.textContent='Checking availability…';
    const abort=new AbortController();
    const timeout=setTimeout(()=>abort.abort(),8000);
    try {
      const root=window.Shopify?.routes?.root || '/';
      const response=await fetch(`${root}products/${encodeURIComponent(controller.root.dataset.productHandle)}?view=ns-batch-stock`,{signal:abort.signal,cache:'no-store'});
      if (!response.ok) throw new Error('Stock check failed');
      const data=await response.json();
      if (data.schema!=='ns-batch-stock-v1' || data.handle!==controller.root.dataset.productHandle || !Array.isArray(data.variants)) throw new Error('Unexpected response');
      if (!data.variants.find(item=>String(item.id)===v.id)?.managed) throw new Error('Batch settings changed');
      controller.refresh(data.variants);
      const fresh=controller.current;
      if (fresh && fresh.id!==v.id) {
        message.textContent='Your selected size changed. Please review it and add it again.';
      } else if (!fresh || fresh.state==='soldout') {
        message.textContent='This size has just sold out. You can request a notification below.';
      } else if (fresh.state==='preorder' && !controller.check.checked) {
        message.textContent='This size is now a pre-order. Please check the dispatch date and confirm below.';
        controller.check.focus();
      } else {
        message.hidden=true;
        controller.bypass=true;
        form.requestSubmit(submitter);
        controller.bypass=false;
      }
    } catch (_) {
      message.textContent='We couldn’t confirm availability. Please try again in a moment.';
    } finally {clearTimeout(timeout);controller.pending=false;}
  }, true);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
